import * as snippet from "@segment/snippet";
import Script from "next/script";

const renderSnippet = (): string => {
  const opts = {
    apiKey: "hyxGgIDPvXkJZ89aYQEXg3XE50A9U0dw",
    // note: the page option only covers SSR tracking.
    page: true,
  };

  if (process.env.NODE_ENV === "development") {
    return snippet.max(opts);
  }

  return snippet.min(opts);
};

function SegmentIntegration() {
  return (
    <Script
      id="segment-script"
      dangerouslySetInnerHTML={{ __html: renderSnippet() }}
    />
  );
}

export default SegmentIntegration;
